import { render } from "./details_index.vue?vue&type=template&id=157734c6"
import script from "./details_index.vue?vue&type=script&lang=js"
export * from "./details_index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__